<script setup>
// import axios from 'axios';
</script>

<template>
    <section class="occBtnContainer">
        <section>
            <span v-if="this.canFinishOccurrence == false" class="statusMsg">{{ this.messageStatus }}</span>
        </section>

        <section>
            <img v-if="this.showAnalysis == true" :disabled="this.canSaveOccurrence == false"
                @click="sentAnalysisFunc"
                :src="'../../../assets/saveNext.png'"
                :title="this.canSaveOccurrence == false ? 'Você não tem permissão para encerrar essa ocorrência.' : $t('start-automatic-validation')"
                :alt='$t("start-automatic-validation")' />

            <img src="@/assets/salvar.png" :alt='$t("salvar-ocorrencia")' :disabled="this.canSaveOccurrence == false"
                :title="this.canSaveOccurrence == false ? 'Você não tem permissão para tratar essa ocorrência.' : $t('salvar-ocorrencia')"
                @click="() => saveOccurrenceFunction(0)" />

            <img v-if="this.canCancelOccurrence == true" :disabled="this.canCancelOccurrence == false" 
                :title="this.canCancelOccurrence == false ? 'Você não tem permissão para cancelar essa ocorrência.' : $t('cancel-occurrence')"
                @click="cancelOccurrenceFunction"
                class="ml-3 cursor-button" src="../../../assets/excluir.png" alt="Cancelar ocorrência" />


            <img src="@/assets/sair.png" :title="$t('sair')" :alt='$t("sair")' @click="closeOccurrenceFunction" />
        </section>
    </section>
</template>

<script>
export default {
    name: 'OccurrencesButtons',
    props: ['saveOccurrenceFunction', 'closeOccurrenceFunction', 'canFinishOccurrence', 'cancelOccurrenceFunction', 'canSaveOccurrence','canCancelOccurrence', 'messageStatus', 'showAnalysis', 'sentAnalysisFunc']
}
</script>

<style scoped>
.occBtnContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.occBtnContainer section {
    display: flex;
    align-items: center;
    column-gap: 1.4rem;
}

.occBtnContainer img {
    width: 40px;
    cursor: pointer;
}

.occBtnContainer svg {
    /* width: 50px;
    height: 50px; */
    border: none;
    font-size: 50px;
    margin: 0;
    padding: 0;
    fill: #ff5f00;
    cursor: pointer;

}

.occBtnContainer svg[disabled="disabled"] {
    fill: gray;
    pointer-events: none;
    cursor: not-allowed;
}

.occBtnContainer img[disabled="disabled"] {
    filter: grayscale(1);
    pointer-events: none;
    cursor: not-allowed;
}

.statusMsg {
    color: #ff5f00;
    font-weight: 500;
    font-size: 0.9rem;
}
</style>